import { useInfiniteQuery } from 'react-query';
import { createFetchAPI } from '../http';

const endpoint = 'v1/invoices';

const fetchInvoices = createFetchAPI<InvoicesParams, InvoicesResponse>(
  endpoint,
);

export const useFetchInvoices = (params: InvoicesParams) =>
  useInfiniteQuery<InvoicesResponse>(
    [
      'fetchInvoices',
      { url: `${endpoint}/${params.finance_account_id}`, ...params },
    ],
    fetchInvoices,
    {
      enabled: !!params.finance_account_id,
      getNextPageParam: () => undefined,
    },
  );

export type InvoicesParams = {
  finance_account_id: number;
  start_date: string;
  end_date: string;
};

export type InvoicesResponse = {
  invoices: Invoice[];
};

export type Invoice = {
  title: string;
  value: string;
};
